import { contactAdapter } from './adapters';
import AjaxUtils from './ajaxUtils';

const fetchContactsList = async (listKey, queryParams = '') => {
  const listKeyParam = listKey === 'all contacts' ? '' : `/${listKey}`;
  const results = await AjaxUtils.get(`/api/v1/contacts${listKeyParam}?${queryParams}`);

  return results?.contacts.map(contact => contactAdapter(contact, results.maskId));
};

export {
  fetchContactsList,
};
